import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { FeatureFlags, SearchType } from '@aibees/elephant/types';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { useFeatureFlagsContext } from '@aibees/shared/feature-flags';

export function useExportTemplateDisabled() {
  const type = useSearchTypeFromRoute();

  const { isFeatureEnabled } = useFeatureFlagsContext();

  const isPeopleExportTempalteEnabled = isFeatureEnabled(
    FeatureFlags.PEOPLE_EXPORT_TEMPLATE
  );
  const isCompanyExportTemplateEnabled = isFeatureEnabled(
    FeatureFlags.COMPANY_EXPORT_TEMPLATE
  );

  return (
    (type === SearchType.People && !isPeopleExportTempalteEnabled) ||
    (type === SearchType.Company && !isCompanyExportTemplateEnabled)
  );
}
